import { render } from "./DashSidebar.vue?vue&type=template&id=56a152df&scoped=true"
import script from "./DashSidebar.vue?vue&type=script&lang=js"
export * from "./DashSidebar.vue?vue&type=script&lang=js"

import "./DashSidebar.vue?vue&type=style&index=0&id=56a152df&scoped=true&lang=css"
import "./DashSidebar.vue?vue&type=style&index=1&id=56a152df&lang=css"

import exportComponent from "/home/runner/work/projeto_logistica/projeto_logistica/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56a152df"],['__file',"src/components/ui/DashSidebar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "56a152df"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('56a152df', __exports__)) {
    console.log('reload')
    api.reload('56a152df', __exports__)
  }
  
  module.hot.accept("./DashSidebar.vue?vue&type=template&id=56a152df&scoped=true", () => {
    console.log('re-render')
    api.rerender('56a152df', render)
  })

}


export default __exports__